import CrudRequest from 'Domain/CrudRequest';
import HttpService from 'Support/services/HttpService';

class RepurchaseRequest extends CrudRequest {
  static baseUrl() {
    return '/v1/recompra';
  }

  static list(queryParams = {}) {
    return HttpService.get(`${this.baseUrl()}/v2/listagemElegiveisRecompra`, {
      params: queryParams,
    });
  }

  static purchase(payload) {
    return HttpService.post(`${this.baseUrl()}/lote/add`, payload);
  }

  static validate(payload) {
    return HttpService.post(
      `${this.baseUrl()}/lote/validar`,
      payload,
    );
  }

  static validateInstallments(payload) {
    return HttpService.post(`${this.baseUrl()}/lote/validar/v2`, payload);
  }

  static purchaseInstallments(payload) {
    return HttpService.post(`${this.baseUrl()}/lote/add/v2`, payload);
  }
}

export default RepurchaseRequest;
